<template>
  <div class="program-chooser">
    <div
      v-for="program in programs"
      :key="program.value_description"
      class="program-item"
    >
      <b-form-radio
        v-model="selected"
        :value="program.value_description"
        @change="assignProgram(program)"
      >
        {{ program.value_description }}
      </b-form-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramChooser",
  props: {
    programs: { type: Array, default: () => [] },
    index: { type: Number, default: 0 },
    selectedprogram: { type: Object, default: () => {} }
  },
  data() {
    return {
      selected: ""
    };
  },
  mounted() {
    if (typeof this.selectedprogram !== "undefined") {
      this.selected = this.selectedprogram.value_description;
    }
  },
  methods: {
    assignProgram(val) {
      this.$emit("input", val, this.index);
    }
  }
};
</script>

<style scoped>
.program-chooser {
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  text-align: left;
}

.program-item {
  width: 50%;
}

@media (max-width: 575px) {
  .program-item {
    width: 100%;
  }
}
</style>
